import HttpClient from './httpClient';

/* This file populates the lists of occupations of the app */
function getOccupations() {
  return new HttpClient.Builder().get('/config/occupation-by-type/').unsecured().execute();
}

export { getOccupations };
